module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"logout":"Logout","welcome":"Welcome","search":"Search"},"es":{"logout":"Cerrar sesión","welcome":"Bienvenido","search":"Buscar"}}')
  delete Component.options._Ctor
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/@kazupon/vue-i18n-loader/lib!./src/i18n/App.i18n.json
// module id = hM8s
// module chunks = 1